// Shared by the leaderboard overview and the full-list page.

// Keys match the API's ageGroup values. An empty key means everyone.
export const AGE_GROUP_OPTIONS = [
  { key: '', label: 'Everyone' },
  { key: 'kids', label: 'Kids 0-12' },
  { key: 'teens', label: 'Teens 13-17' },
  { key: 'adults', label: 'Adults 18-54' },
  { key: 'seniors', label: '55+' }
];

export const isAgeGroupKey = (key) => AGE_GROUP_OPTIONS.some((option) => option.key === key && key !== '');

export const AGE_GROUP_LABELS = Object.fromEntries(
  AGE_GROUP_OPTIONS.filter((option) => option.key).map((option) => [option.key, option.label])
);

// Individual boards. `key` is both the API category and the response value key.
export const INDIVIDUAL_BOARDS = {
  chapters: {
    title: '📖 Top readers by chapters',
    fullTitle: '📖 Individual chapters — season',
    description: 'Top readers ranked by total chapters read',
    valueLabel: 'chapters'
  },
  verses: {
    title: '📜 Top readers by verses',
    fullTitle: '📜 Verses read — season',
    description: 'Top readers ranked by the verses in the chapters they have read',
    valueLabel: 'verses'
  },
  words: {
    title: '🔤 Top readers by words',
    fullTitle: '🔤 Words read — season',
    description: 'Top readers ranked by the words in the chapters they have read',
    valueLabel: 'words'
  },
  weighted: {
    title: '🧭 Coverage score',
    fullTitle: '🧭 Coverage score — season',
    description: 'Verses read, with repeat reads of the same chapter worth less (1st read full, 2nd half, 3rd and later a quarter). Reading the whole Bible beats re-reading a few short chapters.',
    valueLabel: 'points'
  }
};

export const INDIVIDUAL_BOARD_KEYS = Object.keys(INDIVIDUAL_BOARDS);
